import { Box, Typography } from '@mui/material';
import { SafeLinkWithFallback } from '@repo/ui/SafeLinkWithFallback';
import { Rating } from './components/Rating';
import { RatingTooltip, type RatingTooltipProps } from './components/RatingToolTip';

type BaseLayoutProps = {
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
  hideNumber?: boolean;
  smallRatingText?: boolean;
  wrapRatingText?: boolean;
  tooltipProps?: Omit<RatingTooltipProps, 'starRatingTooltip'>;
};

export const BaseLayout = ({
  reviewLink,
  starRating,
  starRatingTooltip,
  hideNumber = false,
  smallRatingText = false,
  wrapRatingText = false,
  tooltipProps,
}: BaseLayoutProps) => {
  if (!starRating) return 'Not yet rated';
  return (
    <Box
      sx={{ display: 'flex', flexWrap: wrapRatingText ? 'wrap' : 'nowrap' }}
      data-testid="rating-component"
    >
      <Box sx={{ display: 'flex', marginBottom: 1 }}>
        <Rating
          value={starRating}
          size="19px"
          gap="5px"
          additionalStyles={{ marginRight: '5px' }}
        />

        {!hideNumber && starRating && starRating !== 0 && (
          <Typography
            variant="textBold"
            sx={{
              marginX: 2,
              fontWeight: 700,
              display: 'inline-block',
              textAlign: 'end',
            }}
          >
            {starRating.toFixed(1)}
          </Typography>
        )}
      </Box>
      <Typography
        variant={smallRatingText ? 'textSmall' : 'text'}
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        <SafeLinkWithFallback href={reviewLink} target="_blank">
          NerdWallet rating{' '}
        </SafeLinkWithFallback>
        {starRatingTooltip && (
          <RatingTooltip starRatingTooltip={starRatingTooltip} {...tooltipProps} />
        )}
      </Typography>
    </Box>
  );
};
